import React, { useEffect, useContext } from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import ReceiptIcon from "@material-ui/icons/Receipt";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import * as Glob from "src/Globale";
import * as Dati from "src/Dati";
import { Trad } from "src/components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _Button, _SearchResultTable } from "../components";
import { _Autocomplete, _DateField } from "../form";
import { GetReceiptsListColumns } from "../components/SearchTableColumns/ReceiptsListColumns";
import useTable from "../hooks/Table";
import { AlertDialogContext } from "../providers/AlertDialogProvider";

export const _ReceiptsList: React.FC<Glob.IRouteGlobaleProps> = props => {
    const { ShowDialog } = useContext(AlertDialogContext);

    const [FormData, setFormData] = useReducerOnChange<Dati.TListaParametri>({ ID_Quietanza: "", ID_Polizza: "", ID_TipoQuietanzaStato: "", ID_TipoQuietanza: "" });
    const { Data, Options, IsLoading, GetData } = useTable("/api/quietanza/ricerca", FormData);

    useEffect(() => {
        if (!Glob.AzioneAbilitata("QuietanzaController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }

        props.SetMenu({ ...Glob.GetMenu(), Main: "Home", ID_MenuMain: 36 });
    }, []);

    const onClickCashOut = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            ShowDialog("ERRORE", data.ErrTesto, "error");
        } else {
            GetData();
        }
    };

    const onApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={ReceiptIcon} Title="Quietanze" />
                <_MainContent>
                    <form noValidate autoComplete="off">
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    id="ID_Quietanza"
                                    label={Trad.Trad("Quietanza")}
                                    value={FormData.ID_Quietanza}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    id="ID_Polizza"
                                    label={Trad.Trad("Polizza")}
                                    value={FormData.ID_Polizza}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_Autocomplete
                                    SearchInput
                                    Value={FormData.ID_TipoQuietanzaStato}
                                    Name="ID_TipoQuietanzaStato"
                                    Label="Stato"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url="/api/Tipi/ListaTipi?ID_TipoContesto=QuietanzaStato"
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_Autocomplete
                                    SearchInput
                                    Value={FormData.ID_TipoQuietanza}
                                    Name="ID_TipoQuietanza"
                                    Label="TipoFile"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url="/api/Tipi/ListaTipi?ID_TipoContesto=Quietanza"
                                />
                            </Grid>
                        </Grid>
                        <Grid>
                            <Grid item md={1}>
                                <_Button
                                    Attivo={!IsLoading}
                                    Testo={Trad.Trad("Cerca")}
                                    OnClick={() => {
                                        Options.onChangePage(0);
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </form>
                    <_SearchResultTable Data={Data} Columns={GetReceiptsListColumns(onClickCashOut, onApiError)} IsLoading={IsLoading} Options={Options} />
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/ReceiptsList.tsx